@if (isExpanded()) {
  <elcia-icon [iconType]="'chevron-down'"/>
} @else {
  <elcia-icon [iconType]="'chevron-right'"/>
}
